import { IconButton } from "@mui/material";
import infoIcon from "Benchmarking/Assets/information.png";
import DepartmentCarousel from "Benchmarking/Components/DepartmentCarousel";
import HorizontalBar from "Benchmarking/Components/HorizontalBar";
import {
  InstitutionPublications,
  InstitutionScholars,
} from "Benchmarking/Components/InstitutionDetailTabComponents";
import KeywordCloudD3 from "Benchmarking/Components/KeywordCloudD3";
import {
  LoadingCircleImage,
  LoadingParagraph,
} from "Benchmarking/Components/LoadingComponent";
import { PaginationAdjustComponentBenchmarking } from "Benchmarking/Components/PaginationComponent";
import SelectSearch from "Benchmarking/Components/SelectSearch";
import VerticalBar from "Benchmarking/Components/VerticalBar";
import "Benchmarking/Scss/InstitutionDetail.scss";
import {
  getInstitutionAdvancedStatById,
  getInstitutionAuthorsByID,
  getInstitutionBasicStatById,
  getInstitutionConceptMap,
  getInstitutionDepartmentById,
  getInstitutionPublicationsByID,
  getInstitutionSummaryById,
} from "Benchmarking/Services/Institution";
import { Popover, Statistic, Tabs, Tooltip } from "antd";
import { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useLocation } from "react-router-dom";

const formatter = (value) => <CountUp end={value} separator="," />;

const InstitutionDetail = () => {
  const institution_id = useLocation().pathname.split("/")[4];
  const [summary, setSummary] = useState();
  const [seeMore, setSeeMore] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });

  const [scholars, setScholars] = useState();
  const [publications, setPublications] = useState();
  const [tab, setTab] = useState("scholars");
  const [basicStat, setBasicStat] = useState({});
  const [advanceStat, setAdvanceStat] = useState({});
  const [citationStatistic, setCitationStatistic] = useState([]);
  //concept word cloud
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [concept, setConcept] = useState([]);
  const [granularityLevel, setGranularityLevel] = useState(1);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [selectedKeywordsQueue, setSelectedKeywordsQueue] = useState([]);
  const [fade, setFade] = useState("");

  //slider
  const [sliderValue, setSliderValue] = useState([1970, 2024]);

  //init data - slider
  useEffect(() => {
    getInstitutionSummaryById(institution_id, (res) => {
      setSummary(res);
    });
    getInstitutionDepartmentById(institution_id, (res) => {
      setDepartments(res);
    });
    getInstitutionBasicStatById(institution_id, (res) => {
      setBasicStat(res);
      const citation_statistic = Object.keys(res.citation_by_publish_year).map(
        (key) => {
          return {
            Year: key,
            Citations: res.citation_by_publish_year[key],
          };
        }
      );
      setCitationStatistic(citation_statistic);
    });
    getInstitutionAdvancedStatById(institution_id, (res) => {
      setAdvanceStat({
        labels: [
          "Faculty members",
          "Citations",
          "Citations per Faculty",
          "Publications",
          "Publications per Faculty",
          "H-index",
        ],
        data: [
          res.number_of_faculties_zscore,
          res.citation_count_zscore,
          res.citation_count_per_faculty_zscore,
          res.number_of_publications_zscore,
          res.number_of_publications_per_faculty_zscore,
          res.index_zscore,
        ],
      });
    });
  }, []);

  useEffect(() => {
    if (selectedKeywordsQueue[selectedKeywordsQueue.length - 1]) {
      let params = new URLSearchParams();
      selectedKeywordsQueue[selectedKeywordsQueue.length - 1].forEach(
        (keyword) => {
          if (keyword) {
            params.append("rootConcept", keyword.real_id);
          }
        }
      );
      getInstitutionConceptMap(
        institution_id,
        sliderValue[0],
        sliderValue[1],
        granularityLevel,
        params.toString(),
        selectedDepartment,
        (res) => {
          setConcept(res.keywords);
          setFade("fade-in");
        }
      );
    } else {
      getInstitutionConceptMap(
        institution_id,
        sliderValue[0],
        sliderValue[1],
        granularityLevel,
        null,
        selectedDepartment,
        (res) => {
          setConcept(res.keywords);
          setFade("fade-in");
        }
      );
    }
  }, [sliderValue, granularityLevel, selectedDepartment]);

  useEffect(() => {
    if (tab == "scholars") {
      setScholars();

      const keywordsForFiltering =
        selectedKeywordsQueue && !selectedKeywords
          ? [...selectedKeywords, ...selectedKeywordsQueue.flat(Infinity)]
          : selectedKeywords;
      getInstitutionAuthorsByID(
        institution_id,
        pagination.page,
        pagination.rowsPerPage,
        sliderValue[0],
        sliderValue[1],
        keywordsForFiltering,
        selectedDepartment,
        (res) => {
          setScholars(res.authors);
          setPagination({ ...pagination, totalRows: res.total });
        }
      );
    }
  }, [
    selectedKeywords,
    sliderValue,
    pagination.page,
    pagination.rowsPerPage,
    tab,
    selectedDepartment,
  ]);

  useEffect(() => {
    if (tab == "publications") {
      setPublications();
      getInstitutionPublicationsByID(
        institution_id,
        pagination.page,
        pagination.rowsPerPage,
        sliderValue[0],
        sliderValue[1],
        selectedKeywords,
        selectedDepartment,
        (res) => {
          setPublications(res.publications);
          setPagination({ ...pagination, totalRows: res.total });
        }
      );
    }
  }, [
    selectedKeywords,
    sliderValue,
    pagination.page,
    pagination.rowsPerPage,
    tab,
    selectedDepartment,
  ]);

  const onChange = (key) => {
    setTab(key);
    setPagination({
      page: 0,
      rowsPerPage: 10,
    });
  };
  const tabs = [
    {
      label: "Scholars",
      key: "scholars",
      children: InstitutionScholars,
      data: scholars,
    },
    {
      label: "Publications",
      key: "publications",
      children: InstitutionPublications,
      data: publications,
    },
  ];

  return (
    <div className="institution-detail-benchmarking">
      <div className="basic-information">
        <div className="bio-institution">
          <div className="avatar">
            <LoadingCircleImage
              width={120}
              height={120}
              data={summary?.photo}
            />
          </div>
          <div className="name">
            <LoadingParagraph
              rows={1}
              data={summary?.inst_name}
              component={
                <p style={{ textAlign: "center" }}>{summary?.inst_name}</p>
              }
            />
          </div>
          <div className="links">
            <Tooltip title={"Official web @ " + summary?.official_web}>
              <IconButton
                aria-label="Personal web"
                size="small"
                target="_blank"
                href={summary?.official_web}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.3607 18.0108C20.3607 20.214 18.4891 22 16.1804 22H7.81965C5.5109 22 3.6393 20.214 3.6393 18.0108V13.133C3.6393 12.4248 3.34447 11.7456 2.81969 11.2448C1.60381 10.0845 1.76187 8.16205 3.15251 7.19692L9.54124 2.763C11.0071 1.74567 12.9929 1.74567 14.4588 2.763L20.8475 7.19691C22.2381 8.16205 22.3962 10.0845 21.1803 11.2448C20.6555 11.7456 20.3607 12.4248 20.3607 13.133V18.0108ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
                    fill="#00A8B5"
                  />
                </svg>
              </IconButton>
            </Tooltip>

            <Tooltip title={"Wikipedia @ " + summary?.wikipedia}>
              <IconButton
                aria-label="Google scholar"
                size="small"
                target="_blank"
                href={summary?.wikipedia}
                disabled={summary?.wikipedia === null}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24px"
                  height="24px"
                >
                  <path
                    fill="var(--blue)"
                    d="M 11 4 L 3 9 L 8.4921875 9 C 8.4715892 9.0754986 8.4383718 9.1441171 8.421875 9.2226562 C 8.375875 9.4646562 8.3398437 9.7308125 8.3398438 10.007812 C 8.3398438 13.578812 11.990234 13.175781 11.990234 13.175781 L 11.990234 14.085938 C 11.990234 14.454937 12.47425 14.327172 12.53125 15.076172 C 12.28925 15.076172 7.4746094 14.937547 7.4746094 18.185547 C 7.4746094 21.445547 11.724609 21.285156 11.724609 21.285156 C 11.724609 21.285156 16.632812 21.504656 16.632812 17.472656 C 16.634813 15.063656 13.822266 14.2795 13.822266 13.3125 C 13.822266 12.3335 15.941406 12.045906 15.941406 9.7539062 C 15.941406 8.7519062 15.872828 8.03825 15.423828 7.53125 C 15.388828 7.49625 15.366031 7.4722188 15.332031 7.4492188 C 15.324304 7.4420199 15.31448 7.4367774 15.306641 7.4296875 L 15.429688 7.4296875 L 17.5 5.8769531 L 17.5 8 A 0.50005 0.50005 0 0 0 17.511719 8.1152344 A 1.0001 1.0001 0 0 0 17 9 L 17 10 A 1.0001 1.0001 0 1 0 19 10 L 19 9 A 1.0001 1.0001 0 0 0 18.488281 8.1152344 A 0.50005 0.50005 0 0 0 18.5 8 L 18.5 5.125 L 20 4 L 11 4 z M 11.691406 7.0527344 C 11.979219 7.0397031 12.268922 7.109625 12.544922 7.265625 C 12.751922 7.369625 12.946141 7.518125 13.119141 7.703125 C 13.476141 8.060125 13.7765 8.5784531 13.9375 9.1894531 C 14.3175 10.640453 13.823828 12.035781 12.798828 12.300781 C 11.784828 12.587781 10.654672 11.641172 10.263672 10.201172 C 10.090672 9.4991719 10.114547 8.8202969 10.310547 8.2792969 C 10.312395 8.2723193 10.316443 8.2666961 10.318359 8.2597656 C 10.321722 8.2581149 10.32682 8.253536 10.330078 8.2519531 C 10.386262 8.0380596 10.478099 7.8461668 10.589844 7.6875 C 10.795388 7.3872165 11.066477 7.1838352 11.404297 7.09375 C 11.499297 7.07075 11.595469 7.0570781 11.691406 7.0527344 z M 12.082031 15.685547 C 13.775031 15.558547 15.216313 16.490813 15.320312 17.757812 C 15.390313 19.013813 14.087812 20.131094 12.382812 20.246094 C 10.689813 20.361094 9.2274844 19.441547 9.1464844 18.185547 C 9.0654844 16.918547 10.377031 15.812547 12.082031 15.685547 z"
                  />
                </svg>
              </IconButton>
            </Tooltip>
          </div>
          <div className="description">
            <div className="line">
              <img src={infoIcon} alt="information" />
              <LoadingParagraph
                component={
                  <div className="description">
                    <p>{summary?.biography}</p>
                    <Popover
                      content={
                        <div
                          style={{
                            width: "500px",
                            height: "300px",
                            overflowY: "scroll",
                          }}
                        >
                          {summary?.biography}
                        </div>
                      }
                      title={summary?.inst_name}
                      trigger="click"
                    >
                      {!seeMore && (
                        <p
                          className="see-more"
                          onClick={() => setSeeMore(true)}
                        >
                          See more
                        </p>
                      )}
                      {seeMore && (
                        <p
                          className="see-more"
                          onClick={() => setSeeMore(false)}
                        >
                          See less
                        </p>
                      )}
                    </Popover>
                  </div>
                }
                data={summary?.biography}
              />
            </div>
          </div>
        </div>
        <div className="institution-detail-word-map">
          <KeywordCloudD3
            keywords={concept}
            selectedKeywords={selectedKeywords}
            setSelectedKeywords={setSelectedKeywords}
            granularityLevel={granularityLevel}
            setGranularityLevel={setGranularityLevel}
            selectedKeywordsQueue={selectedKeywordsQueue}
            setSelectedKeywordsQueue={setSelectedKeywordsQueue}
            sliderValue={sliderValue}
            setSliderValue={setSliderValue}
            bigCloud={false}
          />
        </div>
      </div>
      <div className="academic-result">
        <div className="departments">
          <div className="title-department">
            <p
              style={{
                fontWeight: "bold",
                fontSize: "24px",
              }}
            >
              Departments
            </p>
            <SelectSearch
              data={departments}
              setSelectedDepartment={setSelectedDepartment}
            />
          </div>
          <DepartmentCarousel data={departments} />
        </div>
        <div className="basic-statistic-institution">
          <p
            style={{
              fontWeight: "bold",
              fontSize: "24px",
            }}
          >
            Statistic
          </p>
          <div className="base">
            <Statistic
              className="stat-card"
              title="Faculty members"
              value={basicStat.number_of_faculties}
              formatter={formatter}
            />
            <Statistic
              className="stat-card"
              title="Average seniority"
              value={basicStat.average_seniority}
              formatter={formatter}
            />
            <Statistic
              className="stat-card"
              title="Publications per Faculty"
              value={basicStat.number_of_publications_per_faculty}
              formatter={formatter}
            />
            <Statistic
              className="stat-card"
              title="Citations per Faculty"
              value={basicStat.citation_count_per_faculty}
              formatter={formatter}
            />
            <Statistic
              className="stat-card"
              title="H index"
              value={basicStat["h-index"]}
              formatter={formatter}
            />
          </div>
          <div className="stat-graph">
            <div className="citation-by-year">
              <p className="chart-title">Citations by year</p>
              <VerticalBar data={citationStatistic} />
            </div>
            <div className="advance-param">
              <p className="chart-title">Research z-score</p>
              <HorizontalBar advance_stat={advanceStat} />
            </div>
          </div>
        </div>
        <div className="top-result">
          <Tabs
            onChange={onChange}
            type="card"
            items={tabs.map((item) => {
              return {
                label: item.label,
                key: item.key,
                children: <item.children data={item.data} />,
              };
            })}
          />

          <PaginationAdjustComponentBenchmarking
            pagination={pagination}
            setPagination={setPagination}
          />
        </div>
      </div>
    </div>
  );
};

export default InstitutionDetail;
